import IconButton from '~/components/IconButton';

export default IconButton;
